import React, { useEffect, useRef, useState, createContext, useContext } from 'react';
import { Button, Checkbox, Form, Input, Space, Card, Select, Row, Col, Divider, Flex, Modal } from 'antd';
import StoreSettingService from "services/store_setting";
import ImagePicker from "components/pickers/image/ImagePicker"
import ThemeSetting from "components/pickers/theme-setting"
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
import BlocksEditor from "./block/Editor"
import _, { lowerFirst } from "lodash"
const service = new StoreSettingService();
const HomePageSettingContext = createContext();


const HomePageSetting = () => {
    const [form] = useForm();
    const { showLoading, showNotify, message } = useApp();
    const [blocks, setBlocks] = useState([])
    const [display, setDisplay] = useState("default")
    const [showAdd, setShowAdd] = useState(false);
    const [pageUrl, setPageUrl] = useState("");
    const previewTimerRef = useRef(null);
    useEffect(() => {
        loadData();
    }, []);
    const { editItem, showEditItem, hideEditItem } = useHomePageSetting();
    useEffect(() => {
        if (previewTimerRef.current) {
            clearTimeout(previewTimerRef.current);
        }

        previewTimerRef.current = setTimeout(() => {
            const iframe = document.getElementById("previewIfame");
            if (!iframe?.contentWindow) {
                return;
            }

            iframe.contentWindow.postMessage(
                {
                    sender: "get_page_button2",
                    message: {
                        action: "home_page_changed",
                        data: {
                            display, blocks
                        }
                    }
                },
                "*"
            );
        }, 120);

        return () => {
            if (previewTimerRef.current) {
                clearTimeout(previewTimerRef.current);
            }
        }

    }, [blocks, display])

    const loadData = async () => {
        var setting = await service.getHomePageSetting();
        setDisplay(setting.display);
        setBlocks(setting.blocks);
        var setting2 = await service.getWebsiteSetting();
        if (window.location.host.includes("localhost")) {
            setPageUrl(`http://localhost:3000`);
        } else {
            setPageUrl(`https://${setting2.url}.sipro.store`);
        }


    }

    const onFinish = async values => {
        showLoading(true);
        try {
            await service.saveHomePageSetting(values)
            await loadData();
            showNotify("Đã cập nhật")
        } catch (error) {
            message.error("Không thể nhật")
        }
        showLoading(false);

    };


    const onSave = async () => {
        showLoading(true);
        try {
            await service.saveHomePageSetting({ display: display, blocks: blocks })
            await loadData();
            showNotify("Đã cập nhật")
        } catch (error) {
            message.error("Không thể nhật")
        }
        showLoading(false);
    }


    const onBlocksChange = async (values) => {
        setBlocks(values)
    }

    const onAddProduct = () => {
        var b = {
            id: `_${Math.random()}`,
            type: "product",
            setting: {
                title: "Sản phẩm",
                display: "list",
                products: {
                    method: "list",

                    list: [],
                    tag: [],
                    category: []
                }

            }
        }
        setBlocks([...blocks, b])
        setShowAdd(false)
    }

    const onAddImage = () => {
        var b = {
            id: `_${Math.random()}`,
            type: "image",
            setting: {
                title: "Hình ảnh",
                show_title: false,
                image: null

            }
        }
        setBlocks([...blocks, b])
        setShowAdd(false)
        showEditItem(b.id);
    }



    const onAddMultiImage = () => {
        var b = {
            id: `_${Math.random()}`,
            type: "multi_image",
            setting: {
                title: "Hình ảnh",
                show_title: false,
                display: "carousel",
                images: []

            }
        }
        setBlocks([...blocks, b])
        setShowAdd(false)
        showEditItem(b.id);
    }

    const onAddAllProduct = () => {
        var b = {
            id: `_${Math.random()}`,
            type: "product_all",
            setting: {
                title: "Tất cả sản phẩm",
                show_title: false,

            }
        }
        setBlocks([...blocks, b])
        setShowAdd(false)
        showEditItem(b.id);
    }

    const onAddProductCollection = () => {
        var b = {
            id: `_${Math.random()}`,
            type: "product_collections",
            setting: {
                title: "Bộ sưu tập",
                show_title: true,
                collection_ids: [],
                display: "list",
                slide_config: {
                    autoplay: true,
                },
                common_config: {
                    round_image: false,
                    show_name: true,
                }
            }
        }
        setBlocks([...blocks, b])
        setShowAdd(false)
        showEditItem(b.id);
    }




    return (
        <>

            <Space direction='vertical' style={{ width: "100%" }}>
                <Card title="Thiết kế">
                    <Row gutter={16}>

                        <Col span={12} >
                            <Card title="Xem trước" size='small'>
                                <Flex justify='center'>
                                    <iframe src={pageUrl} style={{ height: 700, width: 450, border: "none", scrollbarWidth: 0 }} id="previewIfame">

                                    </iframe>
                                </Flex>

                            </Card>


                        </Col>
                        <Col span={12}>
                            <Card title="Mẫu trang chủ" size='small'>
                                <Select value={display} onChange={e => setDisplay(e)} options={[{ label: "Mặc định", value: "default" }, { label: "Tuỳ chỉnh", value: "custom" }]} style={{ width: 300 }}> </Select>

                            </Card>
                            {display == "custom" &&
                                <>
                                    <Divider>Thiết kế</Divider>
                                    <BlocksEditor data={blocks} onChange={onBlocksChange}></BlocksEditor>
                                </>
                            }

                            <Divider></Divider>
                            <Flex justify='flex-end'>
                                <Space>
                                    {display == "custom" &&
                                        <Button type='primary' onClick={e => setShowAdd(true)}>Thêm Block</Button>
                                    }
                                    <Button type='primary' onClick={onSave}>Lưu</Button>
                                </Space>

                            </Flex>
                        </Col>


                    </Row>

                </Card>

            </Space>
            <Modal open={showAdd} title="Thêm block" footer={null} onClose={e => setShowAdd(false)} onCancel={e => setShowAdd(false)}>
                <Row gutter={[8, 8]}>
                    <Col span={12}>
                        <Card style={{ width: "100%", }} actions={[<Button onClick={onAddProduct} type='primary'>Thêm</Button>]}>
                            <Card.Meta title="Sản phẩm" description="Danh sách sản phẩm. " >

                            </Card.Meta>

                        </Card>

                    </Col>
                    <Col span={12}>

                        <Card style={{ width: "100%" }} actions={[<Button onClick={onAddImage} type='primary' >Thêm</Button>]}>
                            <Card.Meta title="1 Hình ảnh" description="Thêm hình ảnh" >

                            </Card.Meta>
                        </Card>

                    </Col>
                    <Col span={12}>
                        <Card style={{ width: "100%" }} actions={[<Button onClick={onAddMultiImage} type='primary' >Thêm</Button>]}>
                            <Card.Meta title="Slide ảnh" description="Thêm nhiều hình ảnh" >

                            </Card.Meta>
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card style={{ width: "100%", }} actions={[<Button onClick={onAddAllProduct} type='primary'>Thêm</Button>]}>
                            <Card.Meta title="Toàn bộ sản phẩm" description="Danh sách toàn bộ sản phẩm" >
                            </Card.Meta>
                        </Card>

                    </Col>
                    <Col span={12}>
                        <Card style={{ width: "100%", }} actions={[<Button onClick={onAddProductCollection} type='primary'>Thêm</Button>]}>
                            <Card.Meta title="ProductCollections" description="Hiển thị hình ảnh các collection" >
                            </Card.Meta>
                        </Card>

                    </Col>
                </Row>

            </Modal>
        </>
    )
}

const HomePageSettingWrap = () => {
    const [editItem, setEditItem] = useState(null);
    const showEditItem = (id) => {
        setEditItem(id);
    }
    const hideEditItem = (id) => {
        setEditItem(null)
    }

    return (
        <HomePageSettingContext.Provider value={{ editItem, showEditItem, hideEditItem }}>
            <HomePageSetting></HomePageSetting>
        </HomePageSettingContext.Provider>
    )
}

const useHomePageSetting = () => {
    return useContext(HomePageSettingContext)
}
export default HomePageSettingWrap;
export { useHomePageSetting }